module.exports = __webpack_public_path__ + "img/mosquito.be5030ca.webp";